import { Bell, BellOff } from 'lucide-react';
import { useNotificationPermission } from '@/hooks/usePushNotifications';
import { cn } from '@/lib/utils';

/**
 * Botão no header que solicita permissão de notificação do navegador e
 * persiste a preferência. Estados:
 * - idle: chip neutro "Ativar notificações" (precisa clicar)
 * - granted: chip azul com sino
 * - denied: chip vermelho com sino cortado, sem-ação (precisa habilitar no browser)
 * - unsupported: oculto
 */
export function NotificationToggle() {
  const { state, request, disable } = useNotificationPermission();

  if (state === 'unsupported') return null;

  if (state === 'granted') {
    return (
      <button
        type="button"
        onClick={disable}
        title="Notificações ativadas. Clique para desativar."
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1.5',
          'text-xs font-semibold text-primary transition-colors hover:bg-primary/15',
        )}
      >
        <Bell className="h-4 w-4" />
        <span className="hidden sm:inline">Ativas</span>
      </button>
    );
  }

  if (state === 'denied') {
    return (
      <span
        title="Permissão negada. Habilite nas configurações do navegador."
        className="inline-flex items-center gap-1.5 rounded-full border border-status-blocked/30 bg-status-blocked/10 px-2.5 py-1.5 text-xs font-semibold text-status-blocked"
      >
        <BellOff className="h-4 w-4" />
        <span className="hidden sm:inline">Bloqueado</span>
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={request}
      title="Receber notificações dos eventos das embarcações"
      className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1.5 text-xs font-semibold text-muted-foreground transition-colors hover:bg-accent"
    >
      <Bell className="h-4 w-4" />
      <span className="hidden sm:inline">Ativar</span>
    </button>
  );
}
